module.exports = __webpack_public_path__ + "img/2022-07.c0ff5b18.jpg";